import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "../common/breadcrumb";

import Datatable from "./adminsDatatable";
import { isActiveAdmin } from "./AdminBadge";
import "./admins-kido.css";

import { Search, Shield, Users, UserCheck, UserX, UserPlus } from "react-feather";
import ChangeAdminStatusModal from "./changeAdminStatusModal";
import { connect } from "react-redux";

export class List_admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchFor: "",

      toggleModal: true,
      adminObj: null,
    };
  }

  startToggleModal = async (adminObj) => {
    if (adminObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, adminObj: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        adminObj,
      });
    }
  };

  handleSearchBarChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  render() {
    const { searchFor } = this.state;
    const { allAdmins, currentAdmin } = this.props;
    const renderableAdmins = allAdmins || [];

    const query = searchFor.trim().toLowerCase();
    const filtered = !query
      ? renderableAdmins
      : renderableAdmins.filter((admin) =>
          [admin.mobileNo, admin.name, admin.email].some((v) =>
            String(v || "").toLowerCase().includes(query)
          )
        );

    const active = renderableAdmins.filter(isActiveAdmin).length;
    const stats = [
      { label: "Team members", value: renderableAdmins.length, tone: "sky", Icon: Users },
      { label: "Active", value: active, tone: "mint", Icon: UserCheck },
      { label: "Inactive", value: renderableAdmins.length - active, tone: "rose", Icon: UserX },
    ];

    return (
      <Fragment>
        <ChangeAdminStatusModal
          toggleModal={this.state.toggleModal}
          startToggleModal={this.startToggleModal}
          adminObj={this.state.adminObj}
        />
        <Breadcrumb title="Admin List" parent="Admin" />
        <div className="container-fluid">
          <section className="card kd-orders-card kd-admins">
            <div className="kd-ord-top">
              <div className="kd-ord-title">
                <span className="kd-ord-title-tile kd-st--lilac" aria-hidden="true">
                  <Shield size={20} />
                </span>
                <div>
                  <h2>Team</h2>
                  <svg className="kd-squiggle" viewBox="0 0 120 10" aria-hidden="true" focusable="false">
                    <path d="M2 6 Q12 1 22 6 T42 6 T62 6 T82 6 T102 6 T118 5" />
                  </svg>
                </div>
              </div>

              <form
                className="kd-ord-search"
                role="search"
                onSubmit={(e) => e.preventDefault()}
              >
                <Search size={16} aria-hidden="true" />
                <input
                  name="searchFor"
                  value={searchFor}
                  type="search"
                  placeholder="Search by name, mobile or email"
                  aria-label="Search admins"
                  onChange={this.handleSearchBarChange}
                />
              </form>

              {currentAdmin && currentAdmin.status === "Admin" && (
                <Link
                  to={`${process.env.PUBLIC_URL}/admins/register`}
                  className="btn btn-secondary kd-admins-add"
                >
                  <UserPlus size={15} aria-hidden="true" />
                  Register admin
                </Link>
              )}
            </div>

            <div className="kd-ord-summary">
              <div className="kd-ord-stats kd-admins-stats">
                {stats.map(({ label, value, tone, Icon }, i) => (
                  <div key={label} className={`kd-stat-tag kd-st--${tone}`} style={{ "--i": i }}>
                    <span className="kd-stat-label">
                      <Icon size={13} aria-hidden="true" />
                      {label}
                    </span>
                    <span className="kd-stat-value">{value.toLocaleString()}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="kd-admins-body">
              {query && (
                <p className="kd-admins-found">
                  {filtered.length}{" "}
                  {filtered.length === 1 ? "admin matches" : "admins match"} “{searchFor.trim()}”
                </p>
              )}
              <Datatable
                startToggleModal={this.startToggleModal}
                history={this.props.history}
                myData={filtered}
                emptyText={query ? "No admins match your search." : "No admins yet."}
              />
            </div>
          </section>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allAdmins: state.admins.admins,
    currentAdmin: state.admins.currentAdmin,
  };
};
export default connect(mapStateToProps)(List_admin);
